import { makeAutoObservable } from "mobx";
import { IMoneyDto, IOtherItemsPaymentsDto } from "../rma-types";

class OtherItemRelatedPaymentsStore {

    constructor(
        private _model: IOtherItemsPaymentsDto,
        private _takePaymentCurrencyDataFromMoneyDto: (moneyDtos: IMoneyDto[]) => IMoneyDto | undefined,
        private _getProductNameByProductCaseId: (productCaseId: number) => string | undefined
    ) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get otherItemName(): string | undefined {
        return this._getProductNameByProductCaseId(this._model.product_case_id);
    }

    public get otherItemProductCaseId(): number {
        return this._model.product_case_id;
    }

    public get totalAmount(): IMoneyDto | undefined { return this._takePaymentCurrencyDataFromMoneyDto(this._model.total_amount); }

    public get hasAnyPayment(): boolean {
        return this.totalAmount?.amount !== 0;
    }
}

export default OtherItemRelatedPaymentsStore;
